// ----------------------------------------------------------------------

export const HEADER = {
  vertical: {
    H_MOBILE: 64,
    H_DESKTOP: 56,
    H_DESKTOP_OFFSET: 56,
  },
  horizontal: {
    H_MOBILE: 80,
    H_DESKTOP: 80,
    H_DESKTOP_OFFSET: 80,
  },
  mini: {
    H_MOBILE: 64,
    H_DESKTOP: 56,
    H_DESKTOP_OFFSET: 56,
  },
};

export const NAV = {
  W_VERTICAL: 280,
  W_MINI: 56,
};
